import {
	queryClient,
	type RequirementIdentifier,
	sessionAtom,
	type UserGoogleAdsConsentProvidedValues
} from '@capsicum/common';
import { useAtomValue } from 'jotai';

import {
	useRequirementStateQuery,
	useSetRequirementStateQuery
} from '../data-access/queries/useRequirementStateQueries';

const getKey = (requirementIdentifier: RequirementIdentifier, userId: string) => [
	`get-requirement-state-${requirementIdentifier}-${userId}`
];

export const useGoogleConsentRequirementState = () => {
	const session = useAtomValue(sessionAtom);
	const { data, isFetching, isLoading } = useRequirementStateQuery(
		getKey('google_ads_consent', session?.userId || ''),
		'google_ads_consent',
		!!session
	);
	const { mutateAsync } = useSetRequirementStateQuery();

	return {
		consentToAdPersonalization: !!(data?.userProvidedValues as UserGoogleAdsConsentProvidedValues)
			?.consentToAdPersonalization,
		consentToDataSharing: !!(data?.userProvidedValues as UserGoogleAdsConsentProvidedValues)?.consentToDataSharing,
		isLoading,
		isNotAsked: !!(data && !data.userProvidedValues && !isFetching),
		saveState: (isUserDataSharingAllowed: boolean, isRelevantAdsAllowed: boolean) =>
			mutateAsync({
				requirementIdentifier: 'google_ads_consent',
				state: {
					consentToAdPersonalization: isRelevantAdsAllowed,
					consentToDataSharing: isUserDataSharingAllowed
				}
			}).then(() =>
				queryClient.invalidateQueries({ queryKey: getKey('google_ads_consent', session?.userId || '') })
			)
	};
};
